var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumanAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.666992C4.92893 0.666992 3.25 2.34592 3.25 4.41699C3.25 6.48806 4.92893 8.16699 7 8.16699C9.07107 8.16699 10.75 6.48806 10.75 4.41699C10.75 2.34592 9.07107 0.666992 7 0.666992Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.41699C3.15343 9.41699 0.462271 12.2584 0.127746 15.8168C0.111279 15.992 0.169401 16.166 0.287841 16.2961C0.406281 16.4262 0.574068 16.5003 0.750002 16.5003H13.25C13.4259 16.5003 13.5937 16.4262 13.7122 16.2961C13.8306 16.166 13.8887 15.992 13.8723 15.8168C13.5377 12.2584 10.8466 9.41699 7 9.41699Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanAvatar);
export default __webpack_public_path__ + "static/media/human-avatar.009e6d1b74a5f4eb18dfbbdfd5e3f0cf.svg";
export { ForwardRef as ReactComponent };